import { gql } from "@apollo/client";

export const CREATE_EXAM_SCHEDULE = gql`
  mutation CreateExamSchedule($input: CreateExamScheduleInput!) {
    createExamSchedule(input: $input) {
      id
      schedule_name
      created_at
      created_by
      created_by_id
      updated_at
      updated_by
      updated_by_id
      is_archived
    }
  }
`;

export const UPDATE_EXAM_SCHEDULE = gql`
  mutation UpdateExamSchedule($id: ID!, $input: UpdateExamScheduleInput!) {
    updateExamSchedule(id: $id, input: $input) {
      id
      schedule_name
      updated_at
      updated_by
      updated_by_id
      is_archived
    }
  }
`;

export const CREATE_SCHEDULE_SYLLABUS = gql`
  mutation CreateScheduleSyllabus($input: CreateScheduleSyllabusInput!) {
    createScheduleSyllabus(input: $input) {
      schedule_id
      syllabus_public_pdf_url
      hierarchies_count
    }
  }
`;

export const UPDATE_SCHEDULE_SYLLABUS = gql`
  mutation UpdateScheduleSyllabus($input: UpdateScheduleSyllabusInput!) {
    updateScheduleSyllabus(input: $input) {
      schedule_id
      syllabus_public_pdf_url
      hierarchies_count
    }
  }
`;

